import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, TextProps } from 'react-native';

interface Props extends TextProps {
  colors: [string, string];
}

export const LinearGradientText: React.FC<Props> = ({
  colors,
  ...textProps
}) => {
  const [styles] = useStyles();
  return (
    <Text
      {...textProps}
      style={[
        styles.mask,
        textProps.style,
        {
          // @ts-ignore
          backgroundImage: `linear-gradient(to right, ${colors[0]}, ${colors[1]})`,
        },
      ]}
    />
  );
};

const useStyles = createStyles((theme) => ({
  mask: {
    // color prop not necessarily needed, but we need to coerce
    // the TextStyle type since we're using non-standard properties
    color: theme.colors.transparent,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: theme.colors.transparent,
  },
}));
